type AuthBuilderArgs = {
  formValues: any;
  saved: any;
};

type AuthBuilder = (args: AuthBuilderArgs) => any;

const gatewayAuthBuilders: Record<string, AuthBuilder> = {
  "Pix": ({ formValues, saved }: AuthBuilderArgs) => ({
    name_live:
    formValues?.is_live === true
        ? formValues?.name_live
        ? formValues?.name_live?.trim()
        : ""
        : saved?.inputs?.name_live
        ? saved?.inputs?.name_live
        : "",
    name_test:
    formValues?.is_live === false
        ? formValues?.name_test
        ? formValues?.name_test?.trim()
        : ""
        : saved?.inputs?.name_test
        ? saved?.inputs?.name_test
        : "",

    email_live:
    formValues?.is_live === true
        ? formValues?.email_live
        ? formValues?.email_live?.trim()
        : ""
        : saved?.inputs?.email_live
        ? saved?.inputs?.email_live
        : "",
    // business_name: formValues?.business_name
    //   ? formValues?.business_name?.trim()
    //   : "",
    email_test:
    formValues?.is_live === false
        ? formValues?.email_test
        ? formValues?.email_test?.trim()
        : ""
        : saved?.inputs?.email_test
        ? saved?.inputs?.email_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
    priority: formValues?.priority,
}),

  "Stripe": ({ formValues, saved }: AuthBuilderArgs) => ({
    statement_descriptor: formValues?.statement_descriptor
    ? formValues?.statement_descriptor
    : "",
    statement_descriptor_suffix: formValues?.statement_descriptor_suffix
    ? formValues?.statement_descriptor_suffix
    : "",
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : saved?.inputs?.secret_key_live
        ? saved?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === false
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : saved?.inputs?.secret_key_test?.trim()
        ? saved?.inputs?.secret_key_test
        : "",
    priority: formValues?.priority,
    mark_up: formValues?.mark_up,
}),

  "Raypd": ({ formValues, saved }: AuthBuilderArgs) => ({
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : saved?.inputs?.secret_key_live
        ? saved?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === false
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : saved?.inputs?.secret_key_test
        ? saved?.inputs?.secret_key_test
        : "",
    mid_country_live:
    formValues?.is_live === true
        ? formValues?.mid_country_live
        ? formValues?.mid_country_live?.trim()
        : ""
        : saved?.inputs?.mid_country_live
        ? saved?.inputs?.mid_country_live
        : "",
    mid_country_test:
    formValues?.is_live === false
        ? formValues?.mid_country_test
        ? formValues?.mid_country_test?.trim()
        : ""
        : saved?.inputs?.mid_country_test
        ? saved?.inputs?.mid_country_test
        : "",
    access_key_live:
    formValues?.is_live === true
        ? formValues?.access_key_live
        ? formValues?.access_key_live?.trim()
        : ""
        : saved?.inputs?.access_key_live
        ? saved?.inputs?.access_key_live
        : "",
    access_key_test:
    formValues?.is_live === false
        ? formValues?.access_key_test
        ? formValues?.access_key_test?.trim()
        : ""
        : saved?.inputs?.access_key_test
        ? saved?.inputs?.access_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Banwire": ({ formValues, saved }: AuthBuilderArgs) => ({
    username_live:
    formValues?.is_live === true
        ? formValues?.username_live
        ? formValues?.username_live?.trim()
        : ""
        : saved?.inputs?.username_live
        ? saved?.inputs?.username_live
        : "",
    username_test:
    formValues?.is_live === false
        ? formValues?.username_test
        ? formValues?.username_test?.trim()
        : ""
        : saved?.inputs?.username_test
        ? saved?.inputs?.username_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Valitor": ({ formValues, saved }: AuthBuilderArgs) => ({
    apikey_live:
    formValues?.is_live === true
        ? formValues?.apikey_live
        ? formValues?.apikey_live?.trim()
        : ""
        : saved?.inputs?.apikey_live
        ? saved?.inputs?.apikey_live
        : "",
    apikey_test:
    formValues?.is_live === false
        ? formValues?.apikey_test
        ? formValues?.apikey_test?.trim()
        : ""
        : saved?.inputs?.apikey_test
        ? saved?.inputs?.apikey_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Bambora": ({ formValues, saved }: AuthBuilderArgs) => ({
    merchantId_live:
    formValues?.is_live === true
        ? formValues?.merchantId_live
        ? formValues?.merchantId_live?.trim()
        : ""
        : saved?.inputs?.merchantId_live
        ? saved?.inputs?.merchantId_live
        : "",
    merchantId_test:
    formValues?.is_live === false
        ? formValues?.merchantId_test
        ? formValues?.merchantId_test?.trim()
        : ""
        : saved?.inputs?.merchantId_test
        ? saved?.inputs?.merchantId_test
        : "",
    passcode_live:
    formValues?.is_live === true
        ? formValues?.passcode_live
        ? formValues?.passcode_live?.trim()
        : ""
        : saved?.inputs?.passcode_live
        ? saved?.inputs?.passcode_live
        : "",
    passcode_test:
    formValues?.is_live === false
        ? formValues?.passcode_test
        ? formValues?.passcode_test?.trim()
        : ""
        : saved?.inputs?.passcode_test
        ? saved?.inputs?.passcode_test
        : "",
    hash_key_test:
    formValues?.is_live === false
        ? formValues?.hash_key_test
        ? formValues?.hash_key_test?.trim()
        : ""
        : saved?.inputs?.hash_key_test
        ? saved?.inputs?.hash_key_test
        : "",
    hash_key_live:
    formValues?.is_live === true
        ? formValues?.hash_key_live
        ? formValues?.hash_key_live?.trim()
        : ""
        : saved?.inputs?.hash_key_live
        ? saved?.inputs?.hash_key_live
        : "",
    recurring_passcode_test:
    formValues?.is_live === false
        ? formValues?.recurring_passcode_test
        ? formValues?.recurring_passcode_test?.trim()
        : ""
        : saved?.inputs?.recurring_passcode_test
        ? saved?.inputs?.recurring_passcode_test
        : "",
    recurring_passcode_live:
    formValues?.is_live === true
        ? formValues?.recurring_passcode_live
        ? formValues?.recurring_passcode_live?.trim()
        : ""
        : saved?.inputs?.recurring_passcode_live
        ? saved?.inputs?.recurring_passcode_live
        : "",
    reporting_passcode_test:
    formValues?.is_live === false
        ? formValues?.reporting_passcode_test
        ? formValues?.reporting_passcode_test?.trim()
        : ""
        : saved?.inputs?.reporting_passcode_test
        ? saved?.inputs?.reporting_passcode_test
        : "",
    reporting_passcode_live:
    formValues?.is_live === true
        ? formValues?.reporting_passcode_live
        ? formValues?.reporting_passcode_live?.trim()
        : ""
        : saved?.inputs?.reporting_passcode_live
        ? saved?.inputs?.reporting_passcode_live
        : "",
    batch_passcode_test:
    formValues?.is_live === false
        ? formValues?.batch_passcode_test
        ? formValues?.batch_passcode_test?.trim()
        : ""
        : saved?.inputs?.batch_passcode_test
        ? saved?.inputs?.batch_passcode_test
        : "",
    batch_passcode_live:
    formValues?.is_live === true
        ? formValues?.batch_passcode_live
        ? formValues?.batch_passcode_live?.trim()
        : ""
        : saved?.inputs?.batch_passcode_live
        ? saved?.inputs?.batch_passcode_live
        : "",
    subscription_passcode_test:
    formValues?.is_live === false
        ? formValues?.subscription_passcode_test
        ? formValues?.subscription_passcode_test?.trim()
        : ""
        : saved?.inputs?.subscription_passcode_test
        ? saved?.inputs?.subscription_passcode_test
        : "",
    subscription_passcode_live:
    formValues?.is_live === true
        ? formValues?.subscription_passcode_live
        ? formValues?.subscription_passcode_live?.trim()
        : ""
        : saved?.inputs?.subscription_passcode_live
        ? saved?.inputs?.subscription_passcode_live
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Tangoindia": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_id_live:
    formValues?.is_live === true
        ? formValues?.api_id_live
        ? formValues?.api_id_live?.trim()
        : ""
        : saved?.inputs?.api_id_live
        ? saved?.inputs?.api_id_live
        : "",
    api_id_test:
    formValues?.is_live === false
        ? formValues?.api_id_test
        ? formValues?.api_id_test?.trim()
        : ""
        : saved?.inputs?.api_id_test
        ? saved?.inputs?.api_id_test
        : "",
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "CFGPayments": ({ formValues, saved }: AuthBuilderArgs) => ({
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : saved?.inputs?.secret_key_live
        ? saved?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === false
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : saved?.inputs?.secret_key_test
        ? saved?.inputs?.secret_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Capa": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    webhook_secret_live:
    formValues?.is_live === true
        ? formValues?.webhook_secret_live
        ? formValues?.webhook_secret_live?.trim()
        : ""
        : saved?.inputs?.webhook_secret_live
        ? saved?.inputs?.webhook_secret_live
        : "",
    webhook_secret_test:
    formValues?.is_live === true
        ? formValues?.webhook_secret_test
        ? formValues?.webhook_secret_test?.trim()
        : ""
        : saved?.inputs?.webhook_secret_test
        ? saved?.inputs?.webhook_secret_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Orionx": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : saved?.inputs?.secret_key_live
        ? saved?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === true
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : saved?.inputs?.secret_key_test
        ? saved?.inputs?.secret_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Mauricio": ({ formValues, saved }: AuthBuilderArgs) => ({
    client_id_live:
    formValues?.is_live === true
        ? formValues?.client_id_live
        ? formValues?.client_id_live?.trim()
        : ""
        : saved?.inputs?.client_id_live
        ? saved?.inputs?.client_id_live
        : "",
    client_id_test:
    formValues?.is_live === false
        ? formValues?.client_id_test
        ? formValues?.client_id_test?.trim()
        : ""
        : saved?.inputs?.client_id_test
        ? saved?.inputs?.client_id_test
        : "",
    api_secret_live:
    formValues?.is_live === true
        ? formValues?.api_secret_live
        ? formValues?.api_secret_live?.trim()
        : ""
        : saved?.inputs?.api_secret_live
        ? saved?.inputs?.api_secret_live
        : "",
    api_secret_test:
    formValues?.is_live === true
        ? formValues?.api_secret_test
        ? formValues?.api_secret_test?.trim()
        : ""
        : saved?.inputs?.api_secret_test
        ? saved?.inputs?.api_secret_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Blox": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Terracall": ({ formValues, saved }: AuthBuilderArgs) => ({
    client_id_live:
    formValues?.is_live === true
        ? formValues?.client_id_live
        ? formValues?.client_id_live?.trim()
        : ""
        : saved?.inputs?.client_id_live
        ? saved?.inputs?.client_id_live
        : "",
    client_id_test:
    formValues?.is_live === true
        ? formValues?.client_id_test
        ? formValues?.client_id_test?.trim()
        : ""
        : saved?.inputs?.client_id_test
        ? saved?.inputs?.client_id_test
        : "",
    client_secret_live:
    formValues?.is_live === true
        ? formValues?.client_secret_live
        ? formValues?.client_secret_live?.trim()
        : ""
        : saved?.inputs?.client_secret_live
        ? saved?.inputs?.client_secret_live
        : "",
    client_secret_test:
    formValues?.is_live === true
        ? formValues?.client_secret_test
        ? formValues?.client_secret_test?.trim()
        : ""
        : saved?.inputs?.client_secret_test
        ? saved?.inputs?.client_secret_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "MyXspend": ({ formValues, saved }: AuthBuilderArgs) => ({
    email_live:
    formValues?.is_live === true
        ? formValues?.email_live
        ? formValues?.email_live?.trim()
        : ""
        : saved?.inputs?.email_live
        ? saved?.inputs?.email_live
        : "",
    email_test:
    formValues?.is_live === true
        ? formValues?.email_test
        ? formValues?.email_test?.trim()
        : ""
        : saved?.inputs?.email_test
        ? saved?.inputs?.email_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : saved?.inputs?.password_live
        ? saved?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === true
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : saved?.inputs?.password_test
        ? saved?.inputs?.password_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Bennupay": ({ formValues, saved }: AuthBuilderArgs) => ({
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : saved?.inputs?.secret_key_live
        ? saved?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === true
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : saved?.inputs?.secret_key_test
        ? saved?.inputs?.secret_key_test
        : "",
    brand_id_live:
    formValues?.is_live === true
        ? formValues?.brand_id_live
        ? formValues?.brand_id_live?.trim()
        : ""
        : saved?.inputs?.brand_id_live
        ? saved?.inputs?.brand_id_live
        : "",
    brand_id_test:
    formValues?.is_live === true
        ? formValues?.brand_id_test
        ? formValues?.brand_id_test?.trim()
        : ""
        : saved?.inputs?.brand_id_test
        ? saved?.inputs?.brand_id_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Xorapay": ({ formValues, saved }: AuthBuilderArgs) => ({
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : saved?.inputs?.secret_key_live
        ? saved?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === true
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : saved?.inputs?.secret_key_test
        ? saved?.inputs?.secret_key_test
        : "",
    encryption_key_live:
    formValues?.is_live === true
        ? formValues?.encryption_key_live
        ? formValues?.encryption_key_live?.trim()
        : ""
        : saved?.inputs?.encryption_key_live
        ? saved?.inputs?.encryption_key_live
        : "",
    encryption_key_test:
    formValues?.is_live === true
        ? formValues?.encryption_key_test
        ? formValues?.encryption_key_test?.trim()
        : ""
        : saved?.inputs?.encryption_key_test
        ? saved?.inputs?.encryption_key_test
        : "",
    webhook_hash_live:
    formValues?.is_live === true
        ? formValues?.webhook_hash_live
        ? formValues?.webhook_hash_live?.trim()
        : ""
        : saved?.inputs?.webhook_hash_live
        ? saved?.inputs?.webhook_hash_live
        : "",
    webhook_hash_test:
    formValues?.is_live === true
        ? formValues?.webhook_hash_test
        ? formValues?.webhook_hash_test?.trim()
        : ""
        : saved?.inputs?.webhook_hash_test
        ? saved?.inputs?.webhook_hash_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Murkon": ({ formValues, saved }: AuthBuilderArgs) => ({
    entity_login_live:
    formValues?.is_live === true
        ? formValues?.entity_login_live
        ? formValues?.entity_login_live?.trim()
        : ""
        : saved?.inputs?.entity_login_live
        ? saved?.inputs?.entity_login_live
        : "",
    entity_login_test:
    formValues?.is_live === true
        ? formValues?.entity_login_test
        ? formValues?.entity_login_test?.trim()
        : ""
        : saved?.inputs?.entity_login_test
        ? saved?.inputs?.entity_login_test
        : "",
    entity_pass_live:
    formValues?.is_live === true
        ? formValues?.entity_pass_live
        ? formValues?.entity_pass_live?.trim()
        : ""
        : saved?.inputs?.entity_pass_live
        ? saved?.inputs?.entity_pass_live
        : "",
    entity_pass_test:
    formValues?.is_live === true
        ? formValues?.entity_pass_test
        ? formValues?.entity_pass_test?.trim()
        : ""
        : saved?.inputs?.entity_pass_test
        ? saved?.inputs?.entity_pass_test
        : "",
    entity_code_live:
    formValues?.is_live === true
        ? formValues?.entity_code_live
        ? formValues?.entity_code_live?.trim()
        : ""
        : saved?.inputs?.entity_code_live
        ? saved?.inputs?.entity_code_live
        : "",
    entity_code_test:
    formValues?.is_live === true
        ? formValues?.entity_code_test
        ? formValues?.entity_code_test?.trim()
        : ""
        : saved?.inputs?.entity_code_test
        ? saved?.inputs?.entity_code_test
        : "",
    entity_type_live:
    formValues?.is_live === true
        ? formValues?.entity_type_live
        ? formValues?.entity_type_live?.trim()
        : ""
        : saved?.inputs?.entity_type_live
        ? saved?.inputs?.entity_type_live
        : "",
    entity_type_test:
    formValues?.is_live === true
        ? formValues?.entity_type_test
        ? formValues?.entity_type_test?.trim()
        : ""
        : saved?.inputs?.entity_type_test
        ? saved?.inputs?.entity_type_test
        : "",
    terminal_id_live:
    formValues?.is_live === true
        ? formValues?.terminal_id_live
        ? formValues?.terminal_id_live?.trim()
        : ""
        : saved?.inputs?.terminal_id_live
        ? saved?.inputs?.terminal_id_live
        : "",
    terminal_id_test:
    formValues?.is_live === true
        ? formValues?.terminal_id_test
        ? formValues?.terminal_id_test?.trim()
        : ""
        : saved?.inputs?.terminal_id_test
        ? saved?.inputs?.terminal_id_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Changelly Fiat": ({ formValues, saved }: AuthBuilderArgs) => ({
    public_api_key_live:
    formValues?.is_live === true
        ? formValues?.public_api_key_live
        ? formValues?.public_api_key_live?.trim()
        : ""
        : saved?.inputs?.public_api_key_live
        ? saved?.inputs?.public_api_key_live
        : "",
    public_api_key_test:
    formValues?.is_live === true
        ? formValues?.public_api_key_test
        ? formValues?.public_api_key_test?.trim()
        : ""
        : saved?.inputs?.public_api_key_test
        ? saved?.inputs?.public_api_key_test
        : "",
    private_key_live:
    formValues?.is_live === true
        ? formValues?.private_key_live
        ? formValues?.private_key_live?.trim()
        : ""
        : saved?.inputs?.private_key_live
        ? saved?.inputs?.private_key_live
        : "",
    private_key_test:
    formValues?.is_live === true
        ? formValues?.private_key_test
        ? formValues?.private_key_test?.trim()
        : ""
        : saved?.inputs?.private_key_test
        ? saved?.inputs?.private_key_test
        : "",
    provider_live:
    formValues?.is_live === true
        ? formValues?.provider_live
        ? formValues?.provider_live?.trim()
        : ""
        : saved?.inputs?.provider_live
        ? saved?.inputs?.provider_live
        : "",
    provider_test:
    formValues?.is_live === true
        ? formValues?.provider_test
        ? formValues?.provider_test?.trim()
        : ""
        : saved?.inputs?.provider_test
        ? saved?.inputs?.provider_test
        : "",
    wallet_address_live:
    formValues?.is_live === true
        ? formValues?.wallet_address_live
        ? formValues?.wallet_address_live?.trim()
        : ""
        : saved?.inputs?.wallet_address_live
        ? saved?.inputs?.wallet_address_live
        : "",
    wallet_address_test:
    formValues?.is_live === true
        ? formValues?.wallet_address_test
        ? formValues?.wallet_address_test?.trim()
        : ""
        : saved?.inputs?.wallet_address_test
        ? saved?.inputs?.wallet_address_test
        : "",
    to_currency_live:
    formValues?.is_live === true
        ? formValues?.to_currency_live
        ? formValues?.to_currency_live?.trim()
        : ""
        : saved?.inputs?.to_currency_live
        ? saved?.inputs?.to_currency_live
        : "",
    to_currency_test:
    formValues?.is_live === true
        ? formValues?.to_currency_test
        ? formValues?.to_currency_test?.trim()
        : ""
        : saved?.inputs?.to_currency_test
        ? saved?.inputs?.to_currency_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Changelly Crypto": ({ formValues, saved }: AuthBuilderArgs) => ({
    public_api_key_live:
    formValues?.is_live === true
        ? formValues?.public_api_key_live
        ? formValues?.public_api_key_live?.trim()
        : ""
        : saved?.inputs?.public_api_key_live
        ? saved?.inputs?.public_api_key_live
        : "",
    public_api_key_test:
    formValues?.is_live === true
        ? formValues?.public_api_key_test
        ? formValues?.public_api_key_test?.trim()
        : ""
        : saved?.inputs?.public_api_key_test
        ? saved?.inputs?.public_api_key_test
        : "",
    private_key_live:
    formValues?.is_live === true
        ? formValues?.private_key_live
        ? formValues?.private_key_live?.trim()
        : ""
        : saved?.inputs?.private_key_live
        ? saved?.inputs?.private_key_live
        : "",
    private_key_test:
    formValues?.is_live === true
        ? formValues?.private_key_test
        ? formValues?.private_key_test?.trim()
        : ""
        : saved?.inputs?.private_key_test
        ? saved?.inputs?.private_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Transvoucher": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    api_secret_live:
    formValues?.is_live === true
        ? formValues?.api_secret_live
        ? formValues?.api_secret_live?.trim()
        : ""
        : saved?.inputs?.api_secret_live
        ? saved?.inputs?.api_secret_live
        : "",
    api_secret_test:
    formValues?.is_live === true
        ? formValues?.api_secret_test
        ? formValues?.api_secret_test?.trim()
        : ""
        : saved?.inputs?.api_secret_test
        ? saved?.inputs?.api_secret_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "DNSPay": ({ formValues, saved }: AuthBuilderArgs) => ({
    endpoint_id_live:
    formValues?.is_live === true
        ? formValues?.endpoint_id_live
        ? formValues?.endpoint_id_live?.trim()
        : ""
        : saved?.inputs?.endpoint_id_live
        ? saved?.inputs?.endpoint_id_live
        : "",
    endpoint_id_test:
    formValues?.is_live === true
        ? formValues?.endpoint_id_test
        ? formValues?.endpoint_id_test?.trim()
        : ""
        : saved?.inputs?.endpoint_id_test
        ? saved?.inputs?.endpoint_id_test
        : "",
    merchant_key_live:
    formValues?.is_live === true
        ? formValues?.merchant_key_live
        ? formValues?.merchant_key_live?.trim()
        : ""
        : saved?.inputs?.merchant_key_live
        ? saved?.inputs?.merchant_key_live
        : "",
    merchant_key_test:
    formValues?.is_live === true
        ? formValues?.merchant_key_test
        ? formValues?.merchant_key_test?.trim()
        : ""
        : saved?.inputs?.merchant_key_test
        ? saved?.inputs?.merchant_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Gate2Way": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    api_secret_live:
    formValues?.is_live === true
        ? formValues?.api_secret_live
        ? formValues?.api_secret_live?.trim()
        : ""
        : saved?.inputs?.api_secret_live
        ? saved?.inputs?.api_secret_live
        : "",
    api_secret_test:
    formValues?.is_live === true
        ? formValues?.api_secret_test
        ? formValues?.api_secret_test?.trim()
        : ""
        : saved?.inputs?.api_secret_test
        ? saved?.inputs?.api_secret_test
        : "",
    payment_method_live:
    formValues?.is_live === true
        ? formValues?.payment_method_live
        ? formValues?.payment_method_live?.trim()
        : ""
        : saved?.inputs?.payment_method_live
        ? saved?.inputs?.payment_method_live
        : "",
    payment_method_test:
    formValues?.is_live === true
        ? formValues?.payment_method_test
        ? formValues?.payment_method_test?.trim()
        : ""
        : saved?.inputs?.payment_method_test
        ? saved?.inputs?.payment_method_test
        : "",
    payout_payment_method_live:
    formValues?.is_live === true
        ? formValues?.payout_payment_method_live
        ? formValues?.payout_payment_method_live?.trim()
        : ""
        : saved?.inputs?.payout_payment_method_live
        ? saved?.inputs?.payout_payment_method_live
        : "",
    payout_payment_method_test:
    formValues?.is_live === true
        ? formValues?.payout_payment_method_test
        ? formValues?.payout_payment_method_test?.trim()
        : ""
        : saved?.inputs?.payout_payment_method_test
        ? saved?.inputs?.payout_payment_method_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Payin": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Payouts Tech": ({ formValues, saved }: AuthBuilderArgs) => ({
    client_key_live:
    formValues?.is_live === true
        ? formValues?.client_key_live
        ? formValues?.client_key_live?.trim()
        : ""
        : saved?.inputs?.client_key_live
        ? saved?.inputs?.client_key_live
        : "",
    client_key_test:
    formValues?.is_live === true
        ? formValues?.client_key_test
        ? formValues?.client_key_test?.trim()
        : ""
        : saved?.inputs?.client_key_test
        ? saved?.inputs?.client_key_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : saved?.inputs?.password_live
        ? saved?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === true
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : saved?.inputs?.password_test
        ? saved?.inputs?.password_test
        : "",
    brand_live:
    formValues?.is_live === true
        ? formValues?.brand_live
        ? formValues?.brand_live?.trim()
        : ""
        : saved?.inputs?.brand_live
        ? saved?.inputs?.brand_live
        : "",
    brand_test:
    formValues?.is_live === true
        ? formValues?.brand_test
        ? formValues?.brand_test?.trim()
        : ""
        : saved?.inputs?.brand_test
        ? saved?.inputs?.brand_test
        : "",
    payout_client_key_live:
    formValues?.is_live === true
        ? formValues?.payout_client_key_live
        ? formValues?.payout_client_key_live?.trim()
        : ""
        : saved?.inputs?.payout_client_key_live
        ? saved?.inputs?.payout_client_key_live
        : "",
    payout_client_key_test:
    formValues?.is_live === true
        ? formValues?.payout_client_key_test
        ? formValues?.payout_client_key_test?.trim()
        : ""
        : saved?.inputs?.payout_client_key_test
        ? saved?.inputs?.payout_client_key_test
        : "",
    payout_password_live:
    formValues?.is_live === true
        ? formValues?.payout_password_live
        ? formValues?.payout_password_live?.trim()
        : ""
        : saved?.inputs?.payout_password_live
        ? saved?.inputs?.payout_password_live
        : "",
    payout_password_test:
    formValues?.is_live === true
        ? formValues?.payout_password_test
        ? formValues?.payout_password_test?.trim()
        : ""
        : saved?.inputs?.payout_password_test
        ? saved?.inputs?.payout_password_test
        : "",
    payout_brand_live:
    formValues?.is_live === true
        ? formValues?.payout_brand_live
        ? formValues?.payout_brand_live?.trim()
        : ""
        : saved?.inputs?.payout_brand_live
        ? saved?.inputs?.payout_brand_live
        : "",
    payout_brand_test:
    formValues?.is_live === true
        ? formValues?.payout_brand_test
        ? formValues?.payout_brand_test?.trim()
        : ""
        : saved?.inputs?.payout_brand_test
        ? saved?.inputs?.payout_brand_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "DirectPayment": ({ formValues, saved }: AuthBuilderArgs) => ({
    mid_live:
    formValues?.is_live === true
        ? formValues?.mid_live
        ? formValues?.mid_live?.trim()
        : ""
        : saved?.inputs?.mid_live
        ? saved?.inputs?.mid_live
        : "",
    mid_test:
    formValues?.is_live === true
        ? formValues?.mid_test
        ? formValues?.mid_test?.trim()
        : ""
        : saved?.inputs?.mid_test
        ? saved?.inputs?.mid_test
        : "",
    gateway_live:
    formValues?.is_live === true
        ? formValues?.gateway_live
        ? formValues?.gateway_live?.trim()
        : ""
        : saved?.inputs?.gateway_live
        ? saved?.inputs?.gateway_live
        : "",
    gateway_test:
    formValues?.is_live === true
        ? formValues?.gateway_test
        ? formValues?.gateway_test?.trim()
        : ""
        : saved?.inputs?.gateway_test
        ? saved?.inputs?.gateway_test
        : "",
    key_live:
    formValues?.is_live === true
        ? formValues?.key_live
        ? formValues?.key_live?.trim()
        : ""
        : saved?.inputs?.key_live
        ? saved?.inputs?.key_live
        : "",
    key_test:
    formValues?.is_live === true
        ? formValues?.key_test
        ? formValues?.key_test?.trim()
        : ""
        : saved?.inputs?.key_test
        ? saved?.inputs?.key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "JDPay": ({ formValues, saved }: AuthBuilderArgs) => ({
    merchant_id_live:
    formValues?.is_live === true
        ? formValues?.merchant_id_live
        ? formValues?.merchant_id_live?.trim()
        : ""
        : saved?.inputs?.merchant_id_live
        ? saved?.inputs?.merchant_id_live
        : "",
    merchant_id_test:
    formValues?.is_live === true
        ? formValues?.merchant_id_test
        ? formValues?.merchant_id_test?.trim()
        : ""
        : saved?.inputs?.merchant_id_test
        ? saved?.inputs?.merchant_id_test
        : "",
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    bank_code_live:
    formValues?.is_live === true
        ? formValues?.bank_code_live
        ? formValues?.bank_code_live?.trim()
        : ""
        : saved?.inputs?.bank_code_live
        ? saved?.inputs?.bank_code_live
        : "",
    bank_code_test:
    formValues?.is_live === true
        ? formValues?.bank_code_test
        ? formValues?.bank_code_test?.trim()
        : ""
        : saved?.inputs?.bank_code_test
        ? saved?.inputs?.bank_code_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Portinax": ({ formValues, saved }: AuthBuilderArgs) => ({
    merchant_key_live:
    formValues?.is_live === true
        ? formValues?.merchant_key_live
        ? formValues?.merchant_key_live?.trim()
        : ""
        : saved?.inputs?.merchant_key_live
        ? saved?.inputs?.merchant_key_live
        : "",
    merchant_key_test:
    formValues?.is_live === true
        ? formValues?.merchant_key_test
        ? formValues?.merchant_key_test?.trim()
        : ""
        : saved?.inputs?.merchant_key_test
        ? saved?.inputs?.merchant_key_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : saved?.inputs?.password_live
        ? saved?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === true
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : saved?.inputs?.password_test
        ? saved?.inputs?.password_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

"Paysvara": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    publish_key_live:
    formValues?.is_live === true
        ? formValues?.publish_key_live
        ? formValues?.publish_key_live?.trim()
        : ""
        : saved?.inputs?.publish_key_live
        ? saved?.inputs?.publish_key_live
        : "",
    publish_key_test:
    formValues?.is_live === true
        ? formValues?.publish_key_test
        ? formValues?.publish_key_test?.trim()
        : ""
        : saved?.inputs?.publish_key_test
        ? saved?.inputs?.publish_key_test
        : "",
    profile_id_live:
    formValues?.is_live === true
        ? formValues?.profile_id_live
        ? formValues?.profile_id_live?.trim()
        : ""
        : saved?.inputs?.profile_id_live
        ? saved?.inputs?.profile_id_live
        : "",
    profile_id_test:
    formValues?.is_live === true
        ? formValues?.profile_id_test
        ? formValues?.profile_id_test?.trim()
        : ""
        : saved?.inputs?.profile_id_test
        ? saved?.inputs?.profile_id_test
        : "",
    auth_type_live:
    formValues?.is_live === true
        ? formValues?.auth_type_live
        ? formValues?.auth_type_live?.trim()
        : ""
        : saved?.inputs?.auth_type_live
        ? saved?.inputs?.auth_type_live
        : "",
    auth_type_test:
    formValues?.is_live === true
        ? formValues?.auth_type_test
        ? formValues?.auth_type_test?.trim()
        : ""
        : saved?.inputs?.auth_type_test
        ? saved?.inputs?.auth_type_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

"Rpayz": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    publish_key_live:
    formValues?.is_live === true
        ? formValues?.publish_key_live
        ? formValues?.publish_key_live?.trim()
        : ""
        : saved?.inputs?.publish_key_live
        ? saved?.inputs?.publish_key_live
        : "",
    publish_key_test:
    formValues?.is_live === true
        ? formValues?.publish_key_test
        ? formValues?.publish_key_test?.trim()
        : ""
        : saved?.inputs?.publish_key_test
        ? saved?.inputs?.publish_key_test
        : "",
    profile_id_live:
    formValues?.is_live === true
        ? formValues?.profile_id_live
        ? formValues?.profile_id_live?.trim()
        : ""
        : saved?.inputs?.profile_id_live
        ? saved?.inputs?.profile_id_live
        : "",
    profile_id_test:
    formValues?.is_live === true
        ? formValues?.profile_id_test
        ? formValues?.profile_id_test?.trim()
        : ""
        : saved?.inputs?.profile_id_test
        ? saved?.inputs?.profile_id_test
        : "",
    auth_type_live:
    formValues?.is_live === true
        ? formValues?.auth_type_live
        ? formValues?.auth_type_live?.trim()
        : ""
        : saved?.inputs?.auth_type_live
        ? saved?.inputs?.auth_type_live
        : "",
    auth_type_test:
    formValues?.is_live === true
        ? formValues?.auth_type_test
        ? formValues?.auth_type_test?.trim()
        : ""
        : saved?.inputs?.auth_type_test
        ? saved?.inputs?.auth_type_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

"Paypap": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    secret_key_live:
    formValues?.is_live === true
        ? formValues?.secret_key_live
        ? formValues?.secret_key_live?.trim()
        : ""
        : saved?.inputs?.secret_key_live
        ? saved?.inputs?.secret_key_live
        : "",
    secret_key_test:
    formValues?.is_live === true
        ? formValues?.secret_key_test
        ? formValues?.secret_key_test?.trim()
        : ""
        : saved?.inputs?.secret_key_test
        ? saved?.inputs?.secret_key_test
        : "",
    client_id_live:
    formValues?.is_live === true
        ? formValues?.client_id_live
        ? formValues?.client_id_live?.trim()
        : ""
        : saved?.inputs?.client_id_live
        ? saved?.inputs?.client_id_live
        : "",
    client_id_test:
    formValues?.is_live === true
        ? formValues?.client_id_test
        ? formValues?.client_id_test?.trim()
        : ""
        : saved?.inputs?.client_id_test
        ? saved?.inputs?.client_id_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

"Payporto": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === true
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

"Citigate": ({ formValues, saved }: AuthBuilderArgs) => ({
    merchant_name_live:
    formValues?.is_live === true
        ? formValues?.merchant_name_live
        ? formValues?.merchant_name_live?.trim()
        : ""
        : saved?.inputs?.merchant_name_live
        ? saved?.inputs?.merchant_name_live
        : "",
    merchant_name_test:
    formValues?.is_live === true
        ? formValues?.merchant_name_test
        ? formValues?.merchant_name_test?.trim()
        : ""
        : saved?.inputs?.merchant_name_test
        ? saved?.inputs?.merchant_name_test
        : "",
    merchant_password_live:
    formValues?.is_live === true
        ? formValues?.merchant_password_live
        ? formValues?.merchant_password_live?.trim()
        : ""
        : saved?.inputs?.merchant_password_live
        ? saved?.inputs?.merchant_password_live
        : "",
    merchant_password_test:
    formValues?.is_live === true
        ? formValues?.merchant_password_test
        ? formValues?.merchant_password_test?.trim()
        : ""
        : saved?.inputs?.merchant_password_test
        ? saved?.inputs?.merchant_password_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "TestGateway": ({ formValues, saved }: AuthBuilderArgs) => ({
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Re-set": ({ formValues, saved }: AuthBuilderArgs) => ({
    secretKey_live:
    formValues?.is_live === true
        ? formValues?.secretKey_live
        ? formValues?.secretKey_live?.trim()
        : ""
        : saved?.inputs?.secretKey_live
        ? saved?.inputs?.secretKey_live
        : "",
    secretKey_test:
    formValues?.is_live === false
        ? formValues?.secretKey_test
        ? formValues?.secretKey_test?.trim()
        : ""
        : saved?.inputs?.secretKey_test
        ? saved?.inputs?.secretKey_test
        : "",
    brand_id_live:
    formValues?.is_live === true
        ? formValues?.brand_id_live
        ? formValues?.brand_id_live?.trim()
        : ""
        : saved?.inputs?.brand_id_live
        ? saved?.inputs?.brand_id_live
        : "",
    brand_id_test:
    formValues?.is_live === false
        ? formValues?.brand_id_test
        ? formValues?.brand_id_test?.trim()
        : ""
        : saved?.inputs?.brand_id_test
        ? saved?.inputs?.brand_id_test
        : "",
    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Betapay": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_token_live:
    formValues?.is_live === true
        ? formValues?.api_token_live
        ? formValues?.api_token_live?.trim()
        : ""
        : saved?.inputs?.api_token_live
        ? saved?.inputs?.api_token_live
        : "",
    api_token_test:
    formValues?.is_live === false
        ? formValues?.api_token_test
        ? formValues?.api_token_test?.trim()
        : ""
        : saved?.inputs?.api_token_test
        ? saved?.inputs?.api_token_test
        : "",
    merchant_id_live:
    formValues?.is_live === true
        ? formValues?.merchant_id_live
        ? formValues?.merchant_id_live?.trim()
        : ""
        : saved?.inputs?.merchant_id_live
        ? saved?.inputs?.merchant_id_live
        : "",
    merchant_id_test:
    formValues?.is_live === true
        ? formValues?.merchant_id_test
        ? formValues?.merchant_id_test?.trim()
        : ""
        : saved?.inputs?.merchant_id_test
        ? saved?.inputs?.merchant_id_test
        : "",
    terminal_id_live:
    formValues?.is_live === true
        ? formValues?.terminal_id_live
        ? formValues?.terminal_id_live?.trim()
        : ""
        : saved?.inputs?.terminal_id_live
        ? saved?.inputs?.terminal_id_live
        : "",
    terminal_id_test:
    formValues?.is_live === true
        ? formValues?.terminal_id_test
        ? formValues?.terminal_id_test?.trim()
        : ""
        : saved?.inputs?.terminal_id_test
        ? saved?.inputs?.terminal_id_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Aurea Via": ({ formValues, saved }: AuthBuilderArgs) => ({
    companyNum_live:
    formValues?.is_live === true
        ? formValues?.companyNum_live
        ? formValues?.companyNum_live?.trim()
        : ""
        : saved?.inputs?.companyNum_live
        ? saved?.inputs?.companyNum_live
        : "",
    companyNum_test:
    formValues?.is_live === false
        ? formValues?.companyNum_test
        ? formValues?.companyNum_test?.trim()
        : ""
        : saved?.inputs?.companyNum_test
        ? saved?.inputs?.companyNum_test
        : "",
    personalHashkey_live:
    formValues?.is_live === true
        ? formValues?.personalHashkey_live
        ? formValues?.personalHashkey_live?.trim()
        : ""
        : saved?.inputs?.personalHashkey_live
        ? saved?.inputs?.personalHashkey_live
        : "",
    personalHashkey_test:
    formValues?.is_live === false
        ? formValues?.personalHashkey_test
        ? formValues?.personalHashkey_test?.trim()
        : ""
        : saved?.inputs?.personalHashkey_test
        ? saved?.inputs?.personalHashkey_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Kasha": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",

    merchant_domain_live:
    formValues?.is_live === true
        ? formValues?.merchant_domain_live
        ? formValues?.merchant_domain_live?.trim()
        : ""
        : saved?.inputs?.merchant_domain_live
        ? saved?.inputs?.merchant_domain_live
        : "",
    merchant_domain_test:
    formValues?.is_live === false
        ? formValues?.merchant_domain_test
        ? formValues?.merchant_domain_test?.trim()
        : ""
        : saved?.inputs?.merchant_domain_test
        ? saved?.inputs?.merchant_domain_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Supefina": ({ formValues, saved }: AuthBuilderArgs) => ({
    merchant_id_live:
    formValues?.is_live === true
        ? formValues?.merchant_id_live
        ? formValues?.merchant_id_live?.trim()
        : ""
        : saved?.inputs?.merchant_id_live
        ? saved?.inputs?.merchant_id_live
        : "",
    merchant_id_test:
    formValues?.is_live === false
        ? formValues?.merchant_id_test
        ? formValues?.merchant_id_test?.trim()
        : ""
        : saved?.inputs?.merchant_id_test
        ? saved?.inputs?.merchant_id_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "3xpay": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    
    api_secret_live:
    formValues?.is_live === false
        ? formValues?.api_secret_live
        ? formValues?.api_secret_live?.trim()
        : ""
        : saved?.inputs?.api_secret_live
        ? saved?.inputs?.api_secret_live
        : "",

    api_secret_test:
    formValues?.is_live === false
        ? formValues?.api_secret_test
        ? formValues?.api_secret_test?.trim()
        : ""
        : saved?.inputs?.api_secret_test
        ? saved?.inputs?.api_secret_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Platy 2DS": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : saved?.inputs?.password_live
        ? saved?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === false
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : saved?.inputs?.password_test
        ? saved?.inputs?.password_test
        : "",

    platy_api_key_live:
    formValues?.is_live === false
        ? formValues?.platy_api_key_live
        ? formValues?.platy_api_key_live?.trim()
        : ""
        : saved?.inputs?.platy_api_key_live
        ? saved?.inputs?.platy_api_key_live
        : "",

    platy_api_key_test:
    formValues?.is_live === false
        ? formValues?.platy_api_key_test
        ? formValues?.platy_api_key_test?.trim()
        : ""
        : saved?.inputs?.platy_api_key_test
        ? saved?.inputs?.platy_api_key_test
        : "",

    platy_secret_key_live:
    formValues?.is_live === false
        ? formValues?.platy_secret_key_live
        ? formValues?.platy_secret_key_live?.trim()
        : ""
        : saved?.inputs?.platy_secret_key_live
        ? saved?.inputs?.platy_secret_key_live
        : "",

    platy_secret_key_test:
    formValues?.is_live === false
        ? formValues?.platy_secret_key_test
        ? formValues?.platy_secret_key_test?.trim()
        : ""
        : saved?.inputs?.platy_secret_key_test
        ? saved?.inputs?.platy_secret_key_test
        : "",

    username_live:
    formValues?.is_live === false
        ? formValues?.username_live
        ? formValues?.username_live?.trim()
        : ""
        : saved?.inputs?.username_live
        ? saved?.inputs?.username_live
        : "",

    username_test:
    formValues?.is_live === false
        ? formValues?.username_test
        ? formValues?.username_test?.trim()
        : ""
        : saved?.inputs?.username_test
        ? saved?.inputs?.username_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Platy 3DS": ({ formValues, saved }: AuthBuilderArgs) => ({
    api_key_live:
    formValues?.is_live === true
        ? formValues?.api_key_live
        ? formValues?.api_key_live?.trim()
        : ""
        : saved?.inputs?.api_key_live
        ? saved?.inputs?.api_key_live
        : "",
    api_key_test:
    formValues?.is_live === false
        ? formValues?.api_key_test
        ? formValues?.api_key_test?.trim()
        : ""
        : saved?.inputs?.api_key_test
        ? saved?.inputs?.api_key_test
        : "",
    password_live:
    formValues?.is_live === true
        ? formValues?.password_live
        ? formValues?.password_live?.trim()
        : ""
        : saved?.inputs?.password_live
        ? saved?.inputs?.password_live
        : "",
    password_test:
    formValues?.is_live === false
        ? formValues?.password_test
        ? formValues?.password_test?.trim()
        : ""
        : saved?.inputs?.password_test
        ? saved?.inputs?.password_test
        : "",

    platy_api_key_live:
    formValues?.is_live === false
        ? formValues?.platy_api_key_live
        ? formValues?.platy_api_key_live?.trim()
        : ""
        : saved?.inputs?.platy_api_key_live
        ? saved?.inputs?.platy_api_key_live
        : "",

    platy_api_key_test:
    formValues?.is_live === false
        ? formValues?.platy_api_key_test
        ? formValues?.platy_api_key_test?.trim()
        : ""
        : saved?.inputs?.platy_api_key_test
        ? saved?.inputs?.platy_api_key_test
        : "",

    platy_secret_key_live:
    formValues?.is_live === false
        ? formValues?.platy_secret_key_live
        ? formValues?.platy_secret_key_live?.trim()
        : ""
        : saved?.inputs?.platy_secret_key_live
        ? saved?.inputs?.platy_secret_key_live
        : "",

    platy_secret_key_test:
    formValues?.is_live === false
        ? formValues?.platy_secret_key_test
        ? formValues?.platy_secret_key_test?.trim()
        : ""
        : saved?.inputs?.platy_secret_key_test
        ? saved?.inputs?.platy_secret_key_test
        : "",

    username_live:
    formValues?.is_live === false
        ? formValues?.username_live
        ? formValues?.username_live?.trim()
        : ""
        : saved?.inputs?.username_live
        ? saved?.inputs?.username_live
        : "",

    username_test:
    formValues?.is_live === false
        ? formValues?.username_test
        ? formValues?.username_test?.trim()
        : ""
        : saved?.inputs?.username_test
        ? saved?.inputs?.username_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),

  "Bm2pay": ({ formValues, saved }: AuthBuilderArgs) => ({
    client_id_live:
    formValues?.is_live === true
        ? formValues?.client_id_live
        ? formValues?.client_id_live?.trim()
        : ""
        : saved?.inputs?.client_id_live
        ? saved?.inputs?.client_id_live
        : "",
    client_id_test:
    formValues?.is_live === false
        ? formValues?.client_id_test
        ? formValues?.client_id_test?.trim()
        : ""
        : saved?.inputs?.client_id_test
        ? saved?.inputs?.client_id_test
        : "",

    client_secret_live:
    formValues?.is_live === true
        ? formValues?.client_secret_live
        ? formValues?.client_secret_live?.trim()
        : ""
        : saved?.inputs?.client_secret_live
        ? saved?.inputs?.client_secret_live
        : "",
    client_secret_test:
    formValues?.is_live === false
        ? formValues?.client_secret_test
        ? formValues?.client_secret_test?.trim()
        : ""
        : saved?.inputs?.client_secret_test
        ? saved?.inputs?.client_secret_test
        : "",

    descriptor: formValues?.descriptor,
    mark_up: formValues?.mark_up,
}),
};

export default gatewayAuthBuilders;